import OurServices from "../views/public/OurServices";
import Contact from "../views/public/Contact";
import Home from "../views/public/Home";
import NoMatch from "../views/NoMatch";
import About from "../views/public/About";
import Animals from "../views/public/Animals";
import News from "../views/public/News";

const publicRouter = [
    {
        path: "/prestation",
        component: OurServices,
    },
    {
        path: "/contact",
        component: Contact,
    },
    {
        path: ["/", "/accueil"],
        component: Home,
        exact: true,
    },
    {
        path: "/a-propos",
        component: About,
    },
    {
        path: "/animaux",
        component: Animals,
    },
    {
        path: "/actualites",
        component: News,
    },
    {
        path: "*",
        component: NoMatch,
    },
]

export default publicRouter
